import { environment } from '../environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./content.service";
import * as i2 from "@angular/common/http";
var CategoriesService = /** @class */ (function () {
    function CategoriesService(contentService, http) {
        this.contentService = contentService;
        this.http = http;
        this.categories = [];
    }
    CategoriesService.prototype.ngOnInit = function () {
        var _this = this;
        this.contentService.fetchContent('/categories').subscribe(function (categories) {
            _this.categories = categories;
        });
    };
    CategoriesService.prototype.errorHandler = function (err) {
        if (err.error && err.error.message) {
            alert(err.error.message);
        }
        else if (err.error && err.error._issues) {
            alert(Object.entries(err.error._issues).map(function (entry) {
                return entry[0] + ' : ' + entry[1];
            }).join('\n'));
        }
        else {
            alert('Feil på url: ' + err.url + '\n Status code: ' + err.status + '\n' + err.message);
        }
        return throwError(err);
    };
    CategoriesService.prototype.getCategories = function () {
        //return of(this.categories);
        return this.contentService.fetchContent('/categories');
    };
    CategoriesService.prototype.deleteCategory = function (category) {
        return this.http.delete(environment.BACKEND_SERVER_URL + '/category/' + category.id, { withCredentials: true })
            .pipe(catchError(this.errorHandler));
    };
    CategoriesService.prototype.addCategory = function (category) {
        if (!category.id) {
            delete category.id;
        }
        return this.http.post(environment.BACKEND_SERVER_URL + '/category', category, { withCredentials: true })
            .pipe(catchError(this.errorHandler));
    };
    CategoriesService.prototype.updateCategory = function (category) {
        return this.http.post(environment.BACKEND_SERVER_URL + '/category/' + category.id, category, { withCredentials: true })
            .pipe(catchError(this.errorHandler));
    };
    CategoriesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CategoriesService_Factory() { return new CategoriesService(i0.ɵɵinject(i1.ContentService), i0.ɵɵinject(i2.HttpClient)); }, token: CategoriesService, providedIn: "root" });
    return CategoriesService;
}());
export { CategoriesService };
